import { Box } from 'front-end/src/components'
import React, { FC } from 'react'
import { formColors } from 'shared/basicPalette'

import { BoxProps } from '@chakra-ui/react'
import { radii } from 'front-end/src/components/chakraThemeExtension'

const Fieldset: FC<BoxProps> = ({ ...rest }) => {
  return (
    <Box p="16px" borderRadius={radii.base} bg={formColors.bgColor} {...rest} />
  )
}

export default Fieldset
